import React, { useState } from 'react';
import CustomDrawer from '../../controls/CustomDrawer';
import Button from '../../controls/Button';
import Input from '../../controls/Input';
import Select from '../../controls/Select';

const MarginDrawer = ({
  setDrawer,
  title,
  initialValues,
  onSave
}) => {
  const [values, setValues] = useState({
    Top: initialValues?.Top || "",
    Bottom: initialValues?.Bottom || "",
    Left: initialValues?.Left || "",
    Right: initialValues?.Right || ""
  });

  const handleChange = (field, value) => {
    setValues(prev => ({
      ...prev,
      [field]: value
    }));
  };

  const handleSave = () => {
    onSave(values);
  };

  const handleClose = () => {
    setDrawer(false);
  };

  return (
    <CustomDrawer
      setDrawer={setDrawer}
      title={title}
      drawerType='small'
      buttons={[
        { Label: "Cancel", Type: "secondary", Icon: "roundedRemove" },
        { Label: "Save", Type: "primary", Icon: "save" },
      ]}
      onButtonClick={(label) => {
        if (label === "Save") {
          handleSave();
        } else if (label === "Cancel") {
          handleClose();
        }
      }}
    >
      <div className='flex flex-col gap-4'>
        <Input
          label="Top (px)"
          type={"number"}
          value={values.Top}
          onChange={(e) => handleChange("Top", e.target.value)}
        />
        <Input
          label="Bottom (px)"
          type={"number"}
          value={values.Bottom}
          onChange={(e) => handleChange("Bottom", e.target.value)}
        />
        <Input
          label="Left (px)"
          type={"number"}
          value={values.Left}
          onChange={(e) => handleChange("Left", e.target.value)}
        />
        <Input
          label="Right (px)"
          type={"number"}
          value={values.Right}
          onChange={(e) => handleChange("Right", e.target.value)}
        />
      </div>
    </CustomDrawer>
  );
};

export default MarginDrawer;